import { render, staticRenderFns } from "./BobTheBot.vue?vue&type=template&id=5aa14c08&scoped=true&"
import script from "./BobTheBot.vue?vue&type=script&lang=js&"
export * from "./BobTheBot.vue?vue&type=script&lang=js&"
import style0 from "./BobTheBot.vue?vue&type=style&index=0&id=5aa14c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa14c08",
  null
  
)

export default component.exports